import { BaseClass } from "../master/mastermodel";

export class CareUnitInfoRequest extends BaseClass {
  public CareUnitCode: number;
  public ParentCode: number;
  public UnitName: string;
  public ShortName: string;
  public Description: string;
  public CareUnitType: string;
  public HospitalActorCode: number;
  public MinStaffRequried: number;
  public MaxStaff: number;
  public Remarks: string;
}
export class ShiftTypeInfoRequest extends BaseClass {
  public ShiftTypeCode: number;
  public HospitalActorCode: number;
  public Name: string;
  public FromTime: string;
  public ToTime: string;
  public Status: string;
  public Remarks: string;
  public ShiftTypeName: string;
}
export class StaffTypeInfoRequest extends BaseClass {
  public StaffTypeCode: number;
  public Name: string;
  public Description: string;
  public HospitalActorCode: number;
  public Remarks: string;
}
export class ShiftAllocPatternRequest extends BaseClass {
  public ShiftAllocPatternCode: number;
  public HospitalActorCode: number;
  public ParentCareUnitCode: number;
  public CareUnitCode: number;
  public ShiftTypeCode: number;
  public StaffTypeCode: number;
  public StaffCount: number;
  public Remarks: string;
}
export class ShiftAllocMasterRequest extends BaseClass {
  public ShiftAllocMasterCode: number;
  public ShiftAllocPatternCode: number;
  //public CareUnitCode: number;
  public HospitalActorCode: number;
  //public ShiftTypeCode: number;
  public Date: Date;
  public PlannedStaffCount: number;
  public ActualStaffCount: number;
  public Remarks: string;
}

export class ShiftAllocationRequest extends BaseClass {
  public ShiftAllocationCode: number;
  public ShiftAllocMasterCode: number;
  public NurseActorCode: number;
  public AllocationDate: Date;
  public ShiftStatus: string;
  public IsOvertime: boolean;
  public Remarks: string;
  public HospitalActorCode: number;
  public IsFirm: boolean;
  public Source: string;
  public JobID: number;
}

export class JobOpenRequest extends BaseClass {
  public JobIdentificationCode: number;
  public HospitalActorCode: number; 
  public JoinByDate: Date; //From date
  public OrderDate: Date;
  public ToDate: Date;
  public ContractPeriodInDays: number;
  public CareUnitCode: number; // unit
  public ParentCareUnitCode: number; // dept  
  public Specialty: string; // spl  
  public Remarks: string;
  public StaffNeedCount: number; // how many needed
  public StaffTypeCode: number;// role
  public StaffType: string;
  public JobDescription: string;
  public JobType: string;
  public Status: string;
  public IsFirm: boolean;
  public Department: string;
  public DepartmentCode: number;
  public PreferredShift: string ; // shfit
  public PreferredShiftCode : number;

}

export class JobOpenInfoController {
  public JobIdentificationCode: number;
  public HospitalActorCode: number;
  public JoinByDate: Date; //From date
  public ToDate: Date;
  public ContractPeriodInDays: number;
  public CareUnitCode: number;
  public ParentCareUnitCode: number;
  public ShiftTypeCode: number;
  public Specialty: string;
  public StaffTypeCode: number;
  public Remarks: string;
  public StaffNeedCount: number;
  public JobDescription: string;
  public JobType: string;
  public Status: string;

  

}

export class JobIdentificationRequest extends BaseClass {
  public JobIdentificationCode: number;
  public HospitalActorCode: number;
  public ShiftAllocMasterCode: number;
  public ShiftAllocPatternCode: number;
  public Specialty: string;
  public JobDescription: string;
  public JobType: string;
  public ContractPeriodInDays: number;
  public StaffNeedCount: number;
  public JoinByDate: Date;
  public Status: string;
  public Remarks: string;
}


export class JobFetchRequest extends BaseClass {
  public HospitalActorCode: number;
  //public RegistryActorCode: number;
  public FromDate: Date;
  public ToDate: Date;
  public JoinByDate: Date;

}
export class JobOrderRequest extends BaseClass {
  public JobOrderCode: number;
  public JobIdentificationCode: number;
  public RegistryActorCode: number;
  public HospitalActorCode: number;
  public OrderDate: Date;
  public OrderCount: number;
  public OrderStatus: string;
  public ProposedCopmpensation: string;
  public PayRate: number;

  public Remarks: string;
  public Status: string;
}

export class JobOrderRequest2 extends BaseClass {
  public JobOrderCode: number;
  public OrderDate: Date;
  public RegistryActorCode: number;
  public OrderCount: number;
  public OrderStatus: string;
  public ShiftAllocationCode: number;
  public ShiftAllocMasterCode: number;
 
  public AllocationDate: Date;
  public ShiftStatus: string;
  public IsOvertime: boolean;
  public Remarks: string;
  public HospitalActorCode: number;

  public Source: string;
  public JobID: number;
}




export class RegistryOrdersBetweenDateRequest extends BaseClass {
  public RegistryActorCode: number;
  public FromDate: Date;
  public ToDate: Date;
}
export class OrdersByRegistryBetweenDatesInfoController {
  public JobOrderCode: number;
  public JobCode: number;
  public OrderDate: Date;
  public HospitalActorCode: number;
  public RegistryActorCode: number;
  public OrderCount: number;
  public OrderStatus: string;
  public ProposedCopmpensation: string;
  public Remarks: string;
  public CreatedUser: string;
  public CreatedTimeStamp: Date;
  public RecordStatus: string;
  public JoinByDate: Date;
  public JobType: string;
  public JobDescription: string;
  public ContractPeriodInDays: number;
  public ParentCareUnitName: string;
  public CareUnitName: string;
  public StaffType: string;
  public ShiftType: string;
  public ShiftFromTime: string;
  public ShiftToTime: string;
  public StaffDesc: string;
  public HospitalDisplayname: string;
  public HospitalFacilityCode: number;
  public JobPostCount: number;
}

export class JobOrderDetailsByOrderCodeInfoController {
  public JobOrderCode: number;
  public JobCode: number;
  public OrderDate: Date;
  public HospitalActorCode: number;
  public RegistryActorCode: number;
  public OrderCount: number;
  public OrderStatus: string;
  public ProposedCopmpensation: string;
  public Remarks: string;
  public CreatedUser: string;
  public CreatedTimeStamp: Date;
  public RecordStatus: string;
  public JoinByDate: Date;
  public JobType: string;
  public JobDescription: string;
  public ContractPeriodInDays: number;
  public ParentCareUnitName: string;
  public CareUnitName: string;
  public StaffType: string;
  public ShiftType: string;
  public ShiftFromTime: string;
  public ShiftToTime: string;
  public StaffDesc: string;
  public HospitalDisplayName: string;
  public HospitalFacilityCode: number;
  public JobPostCount: number;
  public JobPostBenefits: string;
  public JobPostDescription: string;
  public JobPostCode: number;
  public PostedDate: Date;
  public PayRate: number;
}
export class JobOrderDetailsByOrderCodeRequest extends BaseClass {
  public JobOrderCode: number;
}
export class JobOrdersBetweenDateRequest extends BaseClass {
  public HospitalActorCode: number;
  public FromDate: Date;
  public ToDate: Date;
}
export class JobOrdersBetweenDatesInfoController {
  public JobOrderCode: number;
  public JobCode: number;
  public OrderDate: Date;
  public RegistryActorCode: number;
  public OrderCount: number;
  public OrderStatus: string;
  public ProposedCopmpensation: string;
  public Remarks: string;
  public CreatedUser: string;
  public CreatedTimeStamp: Date;
  public RecordStatus: string;
  public JoinByDate: Date;
  public JobType: string;
  public JobDescription: string;
  public ContractPeriodInDays: number;
  public ParentCareUnitName: string;
  public CareUnitName: string;
  public StaffType: string;
  public ShiftType: string;
  public RegistryDisplayname: string;
  public RegistryFacilityCode: number;
  public PayRate: number;
}
export class JobPostRequest extends BaseClass {
  public JobPostCode: number;
  public JobOrderCode: number;
  public RegistryActorCode: number;
  public Benefits: string;
  public Description: string;
  public PostedDate: Date;
  public PayRate: number;
}
export class JobPostByRegistryBetweenDateRequest extends BaseClass {
  public RegistryActorCode: number;
  public FromDate: Date;
  public ToDate: Date;
}

export class JobRecommendsByNurseInfoOnDemandRequest extends BaseClass {
  public SearchName: string;
  public StartIndex: number;
  public EndIndex: number;
  public NurseActorCode: number;
}
export class JobRecommendsByNurseInfoOnDemandController {
  public RowNo: number;
  public JobOrderCode: number;
  public JobCode: number;
  public OrderDate: Date;
  public HospitalActorCode: number;
  public RegistryActorCode: number;
  public OrderCount: number;
  public OrderStatus: string;
  public ProposedCopmpensation: string;
  public Remarks: string;
  public JoinByDate: Date;
  public JobType: string;
  public JobDescription: string;
  public ContractPeriodInDays: number;
  public CareUnitName: string;
  public StaffType: string;
  public ShiftType: string;
  public ShiftFromTime: string;
  public ShiftToTime: string;
  public StaffDesc: string;
  public HospitalDisplayName: string;
  public HospitalFacilityCode: number;
  public RegistryDisplayName: string;
  public RegistryFacilityCode: number;
  public JobPostCount: number;
  public JobPostBenefits: string;
  public JobPostDescription: string;
  public JobPostCode: number;
  public PostedDate: Date;
  public ApplicationDate: Date;
  public ApplicationStatus: string;
  public ApplicationRemarks: string;
  public JobApplicationCode: number;
  public HospitalAddressLine1: string;
  public HospitalAddressLine2: string;
  public HospitalCity: string;
  public HospitalState: string;
  public HospitalCountry: string;
  public HospitalCountryLongValue: string;
  public HospitalTelephone1: string;
  public HospitalTelephone2: string;
  public RegistryAddressLine1: string;
  public RegistryAddressLine2: string;
  public RegistryCity: string;
  public RegistryState: string;
  public RegistryCountry: string;
  public RegistryCountryLongValue: string;
  public RegistryTelephone1: string;
  public RegistryTelephone2: string;
  public ActorImageFile: string;
  public ActorImageFileUrl: string;
  public ActorImageCode: number;
  public R2NPayRate: number;
  public JobFormattedCode: number;
}
export class JobApplyDetailsInfoByJobPostWithNurseRequest extends BaseClass {
  public JobPostCode: number;
  public NurseActorCode: number;
}
export class JobApplyDetailsInfoByJobPostWithNurseController {
  public JobOrderCode: number;
  public JobCode: number;
  public OrderDate: Date;
  public HospitalActorCode: number;
  public RegistryActorCode: number;
  public OrderCount: number;
  public OrderStatus: string;
  public ProposedCopmpensation: string;
  public Remarks: string;
  public JoinByDate: Date;
  public JobType: string;
  public JobDescription: string;
  public ContractPeriodInDays: number;
  public CareUnitName: string;
  public StaffType: string;
  public ShiftType: string;
  public ShiftFromTime: string;
  public ShiftToTime: string;
  public StaffDesc: string;
  public HospitalDisplayName: string;
  public HospitalFacilityCode: number;
  public RegistryDisplayName: string;
  public RegistryFacilityCode: number;
  public JobPostCount: number;
  public JobPostBenefits: string;
  public JobPostDescription: string;
  public JobPostCode: number;
  public PostedDate: Date;
  public ApplicationDate: Date;
  public ApplicationStatus: string;
  public ApplicationRemarks: string;
  public JobApplicationCode: number;
  public HospitalAddressLine1: string;
  public HospitalAddressLine2: string;
  public HospitalCity: string;
  public HospitalState: string;
  public HospitalCountry: string;
  public HospitalCountryLongValue: string;
  public HospitalTelephone1: string;
  public HospitalTelephone2: string;
  public RegistryAddressLine1: string;
  public RegistryAddressLine2: string;
  public RegistryCity: string;
  public RegistryState: string;
  public RegistryCountry: string;
  public RegistryCountryLongValue: string;
  public RegistryTelephone1: string;
  public RegistryTelephone2: string;
  public PayRate: number;
  public ActorImageFile: string;
  public ActorImageFileUrl: string;
  public ActorImageCode: number;
}
export class JobApplicationRequest extends BaseClass {
  public JobPostCode: number;
  public JobApplicationCode: number;
  public ApplicantActorCode: number;
  public ApplicationStatus: string;
  public Remarks: string;
  public ApplicationDate: Date;
}


export class JobApplicationsInfoByRegistryRequest extends BaseClass {
  public SearchName: string;
  public StartIndex: number;
  public EndIndex: number;
  public RegistryActorCode: number;
  public NurseActorCode: number;
  public FromDate: Date;
  public ToDate: Date;
  public Location: String;

}
export class JobApplicantDetailsByApplicationCodeRequest extends BaseClass {
  public JobApplicationCode: number;
  // public NurseActorCode: number;
}

export class JobApplicationsInfoByRegistryOnDemandController {
  public RowNo: number;
  public JobOrderCode: number;
  public JobCode: number;
  public OrderDate: Date;
  public HospitalActorCode: number;
  public RegistryActorCode: number;
  public OrderCount: number;
  public OrderStatus: string;
  public ProposedCopmpensation: string;
  public Remarks: string;
  public JoinByDate: Date;
  public JobType: string;
  public JobDescription: string;
  public ContractPeriodInDays: number;
  public CareUnitName: string;
  public StaffType: string;
  public ShiftType: string;
  public ShiftFromTime: string;
  public ShiftToTime: string;
  public StaffDesc: string;
  public HospitalDisplayName: string;
  public HospitalFacilityCode: number;
  public RegistryDisplayName: string;
  public RegistryFacilityCode: number;
  public JobPostCount: number;
  public JobPostBenefits: string;
  public JobPostDescription: string;
  public JobPostCode: number;
  public PostedDate: Date;
  public ApplicationDate: Date;
  public ApplicationStatus: string;
  public ApplicationRemarks: string;
  public JobApplicationCode: number;
  public HospitalAddressLine1: string;
  public HospitalAddressLine2: string;
  public HospitalCity: string;
  public HospitalState: string;
  public HospitalCountry: string;
  public HospitalCountryLongValue: string;
  public HospitalTelephone1: string;
  public HospitalTelephone2: string;
  public RegistryAddressLine1: string;
  public RegistryAddressLine2: string;
  public RegistryCity: string;
  public RegistryState: string;
  public RegistryCountry: string;
  public RegistryCountryLongValue: string;
  public RegistryTelephone1: string;
  public JobFormattedCode: string;
  public RegistryTelephone2: string;
  public NurseDisplayName: string;
  public NurseImageFile: string;
  public NurseImageFileExtension: string;
  public NurseImageFileUrl: string;
  public NurseImageCode: number;
  public NurseActorCode: number;
  public Department: string;
  public Specialty: string;

  public NurseResponse: string;
  public HospitalResponse: string;

  GetShiftStatus() {

    if (!this.NurseResponse && !this.HospitalResponse ) {
      return "";
    }

    if (this.NurseResponse == 'Accepted' && this.HospitalResponse == 'Accepted')
      return "Shift Confirmed";
    if (this.NurseResponse == 'Accepted' && !this.HospitalResponse)
      return "Waiting for Hospital Acceptance";
    if (this.NurseResponse == 'Accepted' && this.HospitalResponse == 'Rejected')
      return "Hospital Rejected";
    if (this.NurseResponse == 'Rejected')
      return "Shift Rejected";
    return "";

  }
}
export class SaveShiftStatusRequest extends BaseClass
{
  public ShiftAllocationCode: number;
  public NurseActorCode: number;
  public HospitalActorCode: number;
  public Status: string;

}
export class ShiftAllocationsByJobIDController {
  public RowNo: number;
  public JobOrderCode: number;
  public JobCode: number;
  public OrderDate: Date;
  public HospitalActorCode: number;
  public RegistryActorCode: number;
  public OrderCount: number;
  public OrderStatus: string;
  public ProposedCopmpensation: string;
  public Remarks: string;
  public JoinByDate: Date;
  public JobType: string;
  public JobDescription: string;
  public ContractPeriodInDays: number;
  public CareUnitName: string;
  public StaffType: string;
  public ShiftType: string;
  public ShiftFromTime: string;
  public ShiftToTime: string;
  public StaffDesc: string;
  public HospitalDisplayName: string;
  public HospitalFacilityCode: number;
  public RegistryDisplayName: string;
  public RegistryFacilityCode: number;
  public JobPostCount: number;
  public JobPostBenefits: string;
  public JobPostDescription: string;
  public JobPostCode: number;
  public PostedDate: Date;
  public ApplicationDate: Date;
  public ApplicationStatus: string;
  public ApplicationRemarks: string;
  public JobApplicationCode: number;
  public HospitalAddressLine1: string;
  public HospitalAddressLine2: string;
  public HospitalCity: string;
  public HospitalState: string;
  public HospitalCountry: string;
  public HospitalCountryLongValue: string;
  public HospitalTelephone1: string;
  public HospitalTelephone2: string;
  public RegistryAddressLine1: string;
  public RegistryAddressLine2: string;
  public RegistryCity: string;
  public RegistryState: string;
  public RegistryCountry: string;
  public RegistryCountryLongValue: string;
  public RegistryTelephone1: string;
  public RegistryTelephone2: string;
  public NurseDisplayName: string;
  public NurseImageFile: string;
  public NurseImageFileExtension: string;
  public NurseImageFileUrl: string;
  public NurseImageCode: number;
  public NurseActorCode: number;
  public Department: string;
  public Specialty: string;

  public IsSelected: boolean;
  public HospitalResponse: string;
  public NurseResponse: string;
}


export class JobApplicantDetailsByApplicationCodeController {
  public JobOrderCode: number;
  public JobCode: number;
  public OrderDate: Date;
  public HospitalActorCode: number;
  public RegistryActorCode: number;
  public OrderCount: number;
  public OrderStatus: string;
  public ProposedCopmpensation: string;
  public Remarks: string;
  public JoinByDate: Date;
  public JobType: string;
  public JobDescription: string;
  public ContractPeriodInDays: number;
  public CareUnitName: string;
  public StaffType: string;
  public StaffTypeCode: number;
  public ShiftType: string;
  public ShiftTypeCode: number;
  public ShiftFromTime: string;
  public ShiftToTime: string;
  public StaffDesc: string;
  public HospitalDisplayName: string;
  public HospitalFacilityCode: number;
  public RegistryDisplayName: string;
  public RegistryFacilityCode: number;
  public JobPostCount: number;
  public JobPostBenefits: string;
  public JobPostDescription: string;
  public JobPostCode: number;
  public PostedDate: Date;
  public ApplicationDate: Date;
  public ApplicationStatus: string;
  public ApplicationRemarks: string;
  public JobApplicationCode: number;
  public HospitalAddressLine1: string;
  public HospitalAddressLine2: string;
  public HospitalCity: string;
  public HospitalState: string;
  public HospitalCountry: string;
  public HospitalCountryLongValue: string;
  public HospitalTelephone1: string;
  public HospitalTelephone2: string;
  public RegistryAddressLine1: string;
  public RegistryAddressLine2: string;
  public RegistryCity: string;
  public RegistryState: string;
  public RegistryCountry: string;
  public RegistryCountryLongValue: string;
  public RegistryTelephone1: string;
  public RegistryTelephone2: string;
  public NurseDisplayName: string;
  public NurseImageFile: string;
  public NurseImageFileExtension: string;
  public NurseImageFileUrl: string;
  public NurseImageCode: number;
  public NurseActorCode: number;

  public JobApplicationForwardCode: number;
  public ApplicationForwardStatus: string;
  public ApplicationForwardDate: Date;
  public ForwardRemarks: string;


  public JobOfferCode: number;
  public JoinDateProposed: Date;
  public OfferDate: Date;
  public OfferStatus: string;
  public OfferRemarks: string;
}


export class JobApplicationTrackRequest extends BaseClass {
  public JobApplicationTrackCode: number;
  public JobApplicationCode: number;
  public ApplicationStatus: string;
  public Remarks: string;
  public ApplicationTrackDate: Date;
}

//
export class JobApplicationForwardRequest extends BaseClass {
  public JobApplicationForwardCode: number;
  public JobApplicationCode: number;
  public ApplicantActorCode: number;
  public ForwardedByRegistryActorCode: number;
  public ForwardToHospitalActorCode: number;
  public ApplicationForwardStatus: string;
  public ForwardRemarks: string;
  public ApplicationForwardDate: Date;
}
//
export class ForwardedApplicantsToHospitalInfoRequest extends BaseClass {
  public SearchName: string;
  public StartIndex: number;
  public EndIndex: number;
  public HospitalActorCode: number;
}
//
export class ForwardedApplicantsToHospitalInfoOnDemandController {
  public RowNo: number;
  public JobOrderCode: number;
  public JobCode: number;
  public OrderDate: Date;
  public HospitalActorCode: number;
  public RegistryActorCode: number;
  public OrderCount: number;
  public OrderStatus: string;
  public ProposedCopmpensation: string;
  public Remarks: string;
  public JoinByDate: Date;
  public JobType: string;
  public JobDescription: string;
  public ContractPeriodInDays: number;
  public CareUnitName: string;
  public StaffType: string;
  public ShiftType: string;
  public ShiftFromTime: string;
  public ShiftToTime: string;
  public StaffDesc: string;
  public HospitalDisplayName: string;
  public HospitalFacilityCode: number;
  public RegistryDisplayName: string;
  public RegistryFacilityCode: number;
  public JobPostCount: number;
  public JobPostBenefits: string;
  public JobPostDescription: string;
  public JobPostCode: number;
  public PostedDate: Date;
  public ApplicationDate: Date;
  public ApplicationStatus: string;
  public ApplicationRemarks: string;
  public JobApplicationCode: number;
  public HospitalAddressLine1: string;
  public HospitalAddressLine2: string;
  public HospitalCity: string;
  public HospitalState: string;
  public HospitalCountry: string;
  public HospitalCountryLongValue: string;
  public HospitalTelephone1: string;
  public HospitalTelephone2: string;
  public RegistryAddressLine1: string;
  public RegistryAddressLine2: string;
  public RegistryCity: string;
  public RegistryState: string;
  public RegistryCountry: string;
  public RegistryCountryLongValue: string;
  public RegistryTelephone1: string;
  public RegistryTelephone2: string;
  public NurseDisplayName: string;
  public NurseImageFile: string;
  public NurseImageFileExtension: string;
  public NurseImageFileUrl: string;
  public NurseImageCode: number;
  public NurseActorCode: number;
  public JobApplicationForwardCode: number;
  public ApplicationForwardStatus: string;
  public ApplicationForwardDate: Date;
  public ForwardRemarks: string;
}
export class ForwardedApplicantDetailsByForwardCodeRequest extends BaseClass {
  public JobApplicationForwardCode: number;
}
export class ForwardedApplicantDetailsByForwardCodeController {
  public JobOrderCode: number;
  public JobCode: number;
  public OrderDate: Date;
  public HospitalActorCode: number;
  public RegistryActorCode: number;
  public OrderCount: number;
  public OrderStatus: string;
  public ProposedCopmpensation: string;
  public Remarks: string;
  public JoinByDate: Date;
  public JobType: string;
  public JobDescription: string;
  public ContractPeriodInDays: number;
  public CareUnitName: string;
  public StaffType: string;
  public ShiftType: string;
  public ShiftFromTime: string;
  public ShiftToTime: string;
  public StaffDesc: string;
  public HospitalDisplayName: string;
  public HospitalFacilityCode: number;
  public RegistryDisplayName: string;
  public RegistryFacilityCode: number;
  public JobPostCount: number;
  public JobPostBenefits: string;
  public JobPostDescription: string;
  public JobPostCode: number;
  public PostedDate: Date;
  public ApplicationDate: Date;
  public ApplicationStatus: string;
  public ApplicationRemarks: string;
  public JobApplicationCode: number;
  public HospitalAddressLine1: string;
  public HospitalAddressLine2: string;
  public HospitalCity: string;
  public HospitalState: string;
  public HospitalCountry: string;
  public HospitalCountryLongValue: string;
  public HospitalTelephone1: string;
  public HospitalTelephone2: string;
  public RegistryAddressLine1: string;
  public RegistryAddressLine2: string;
  public RegistryCity: string;
  public RegistryState: string;
  public RegistryCountry: string;
  public RegistryCountryLongValue: string;
  public RegistryTelephone1: string;
  public RegistryTelephone2: string;
  public NurseDisplayName: string;
  public NurseImageFile: string;
  public NurseImageFileExtension: string;
  public NurseImageFileUrl: string;
  public NurseImageCode: number;
  public NurseActorCode: number;
  public JobApplicationForwardCode: number;
  public ApplicationForwardStatus: string;
  public ApplicationForwardDate: Date;
  public ForwardRemarks: string;
}
//
export class JobOfferRequest extends BaseClass {
  public JobOfferCode: number;
  public HospitalActorCode: number;
  public RegistryActorCode: number;
  public JobApplicationCode: number;
  public ApplicantActorCode: number;
  public JobApplicationTrackCode: number;
  public JobApplicationForwardCode: number;
  public JoinDateProposed: Date;
  public OfferStatus: string;
  public Remarks: string;
  public OfferDate: Date;
  public JobPostCode: number;
  public JobIdentificationCode: number;
}

export class ParentCareUnitsInfoController {
  public CareUnitCode: number;
  public ParentCode: number;
  public UnitName: string;
  public ShortName: string;
  public Description: string;
  public CareUnitType: string;
  public HospitalActorCode: number;
  public MinStaffRequried: number;
  public MaxStaff: number;
  public Remarks: string;
  public RecordStatus: string;
  public CreatedUser: string;
  public CreatedTimeStamp: Date;
}

export class CareUnitByParentCodeInfoController {
  public CareUnitCode: number;
  public ParentCode: number;
  public UnitName: string;
  public ShortName: string;
  public Description: string;
  public CareUnitType: string;
  public HospitalActorCode: number;
  public MinStaffRequried: number;
  public MaxStaff: number;
  public Remarks: string;
  public RecordStatus: string;
  public CreatedUser: string;
  public CreatedTimeStamp: Date;
}
export class ShiftTypeInfoController {
  public ShiftTypeCode: number;
  public HospitalActorCode: number;
  public Name: string;
  public FromTime: string;
  public ToTime: string;
  public Status: string;
  public Remarks: string;
  public CreatedUser: string;
  public CreatedTimeStamp: Date;
  public RecordStatus: string;
  public ShiftTypeName: string;
}
export class StaffTypeInfoController {
  public StaffTypeCode: number;
  public HospitalActorCode: number;
  public Name: string;
  public Description: string;
  public Remarks: string;
  public CreatedUser: string;
  public CreatedTimeStamp: Date;
  public RecordStatus: string;
}
export class ShiftAllocPatternByCareUnitInfoController {

  public ShiftAllocPatternCode: number;
  public HospitalActorCode: number;
  public ParentCareUnitCode: number;
  public CareUnitCode: number;
  public ShiftTypeCode: number;
  public StaffTypeCode: number;
  public StaffCount: number;
  public Remarks: string;
  public CreatedUser: string;
  public CreatedTimeStamp: Date;
  public RecordStatus: string;
  public CareUnitType: string;
  public ParentCareUnitName: string;
  public CareUnitName: string;
  public ShiftType: string;
  public StaffType: string;
}
export class ShiftAllocPatternInfoController {
  public ShiftAllocPatternCode: number;
  public HospitalActorCode: number;
  public ParentCareUnitCode: number;
  public CareUnitCode: number;
  public ShiftTypeCode: number;
  public StaffTypeCode: number;
  public StaffCount: number;
  public Remarks: string;
  public CreatedUser: string;
  public CreatedTimeStamp: Date;
  public RecordStatus: string;
  public CareUnitType: string;
  public ParentCareUnitName: string;
  public CareUnitName: string;
  public ShiftType: string;
  public StaffType: string;
}
export class ShiftAllocMasterByDateInfoController {
  public ShiftAllocMasterCode: number;
  public HospitalActorCode: number;
  public ParentCareUnitCode: number;
  public CareUnitCode: number;
  public ShiftTypeCode: number;
  public StaffTypeCode: number;
  public CareUnitType: string;
  public CareUnitName: string;
  public ParentCareUnitName: string;
  public StaffType: string;
  public ShiftType: string;
  public Date: Date;
  public PlannedStaffCount: number;
  public ActualStaffCount: number;
  public Remarks: string;
  public CreatedUser: string;
  public CreatedTimeStamp: Date;
  public RecordStatus: string;
  public ShiftAllocPatternCode: number;
  public ResourceIdentifiedCount: number;
}
export class ShiftAllocationByDateInfoController {
  public ShiftAllocationCode: number;
  public ShiftAllocMasterCode: number;
  public NurseActorCode: number;
  public AllocationDate: Date;
  public ShiftStatus: string;
  public IsOvertime: boolean;
  public Remarks: string;
  public CreatedUser: string;
  public CreatedTimeStamp: Date;
  public RecordStatus: string;
  public NurseName: string;
  public StaffType: string;
  public CareUnit: string;
  public ShiftName: string;
}
export class ResourceIdentificationByDateInfoController {
  public JobIdentificationCode: number;
  public HospitalActorCode: number;
  public ShiftAllocMasterCode: number;
  public ShiftAllocPatternCode: number;
  public ParentCareUnitCode: number;
  public CareUnitCode: number;
  public ShiftTypeCode: number;
  public StaffTypeCode: number;
  public CareUnitType: string;
  public ParentCareUnitName: string;
  public CareUnitName: string;
  public StaffType: string;
  public ShiftType: string;
  public Specialty: string;
  public ContractPeriodInDays: number;
  public StaffNeedCount: number;
  public JoinByDate: Date;
  public JobDescription: string;
  public JobType: string;
  public Remarks: string;
  public CreatedUser: string;
  public CreatedTimeStamp: Date;
  //public CareUnitType1: string;
  //public CareUnitName1: string;
  public MinStaffRequriedOnCareUnit: number;
  public MaxStaffNotExceedOnCareUnit: number;
  public JobOrderedCount: number;
  public OrderCount: number;
  public AppliedCount: number;
  public AssignedCount: number;
  public ShiftRequestCount: number;
  public JobFormattedCode: number;
  public Status: string;
}
export class ResourceOrdersByJobIDInfoController {
  public JobOrderCode: number;
  public JobCode: number;
  public RegistryActorCode: number;
  public OrderCount: number;
  public OrderStatus: string;
  public ProposedCopmpensation: string;
  public Remarks: string;
  public CreatedUser: string;
  public CreatedTimeStamp: Date;
  public RecordStatus: string;
  public RegistryDisplayname: string;
  public PayRate: number;

}
export class JobPostInfoByRegistryBetweenDateController {
  public JobPostCode: number;
  public JobOrderCode: number;
  public RegistryActorCode: number;
  public Description: string;
  public Benefits: string;
  public PostedDate: Date;
  public CreatedUser: string;
  public CreatedTimeStamp: Date;
  public RecordStatus: string;
  public PayRate: number;
}
export class JobApplicationsByJobPostInfoController {
  public JobApplicationCode: number;
  public JobPostCode: number;
  public ApplicantActorCode: number;
  public ApplicationStatus: string;
  public ApplicationDate: Date;
  public Remarks: string;
  public CreatedUser: string;
  public RecordStatus: string;
}
export class JobAppTrackByAppCodeInfoController {
  public JobApplicationTrackCode: number;
  public JobApplicationCode: number;
  public ApplicationTrackDate: Date;
  public ApplicationStatus: string;
  public Remarks: string;
  public CreatedUser: string;
  public CreatedTimeStamp: Date;
  public RecordStatus: string;
}
export class JobOfferByJobPostInfoController {
  public JobOfferCode: number;
  public HospitalActorCode: number;
  public RegistryActorCode: number;
  public ApplicantActorCode: number;
  public JobApplicationCode: number;
  public OfferDate: Date;
  public JoinDateProposed: Date;
  public OfferStatus: string;
  public Remarks: string;
  public CreatedUser: string;
  public CreatedTimeStamp: Date;
  public RecordStatus: string;
  public JoBApplicationDate: Date;
  public ApplicantName: string;
  public JobBenefits: string;
  public RegistryDisplayName: string;
}
export class JobOfferByJobCodeInfoController {
  public JobOfferCode: number;
  public HospitalActorCode: number;
  public RegistryActorCode: number;
  public ApplicantActorCode: number;
  public JobApplicationCode: number;
  public OfferDate: Date;
  public JoinDateProposed: Date;
  public OfferStatus: string;
  public Remarks: string;
  public CreatedUser: string;
  public CreatedTimeStamp: Date;
  public RecordStatus: string;
  public JoBApplicationDate: Date;
  public ApplicantName: string;
  public JobBenefits: string;
  public RegistryDisplayName: string;
}


export class ReleaseOfferAndContractRequest extends BaseClass {
  public JobOfferCode: number;
  public HospitalActorCode: number;
  public RegistryActorCode: number;
  public JobApplicationCode: number;
  public JobApplicationForwardCode: number;
  public ApplicantActorCode: number;
  public JoinDateProposed: Date;
  public OfferStatus: string;
  public Remarks: string;
  public OfferDate: Date;
  public OfferReleaseDate: Date;
  public ContractPeriodInDays: number;

  public StaffType: string;
  public StaffTypeCode: number;
  public PreferedShiftType: string;
  public PreferedShiftTypeCode: number;
}

export class xRejectJobApplicationRequest extends BaseClass {
  public JobApplicationCode: number;
  public ApplicationStatus: string;
  public JobApplicationForwardCode: number;
  public Remarks: string;
}


export class JobContractsBetweenDateRequest extends BaseClass {
  public HospitalActorCode: number;
  public FromDate: Date;
  public ToDate: Date;
}

export class JobContractsBetweenDatesInfoController {
  public JobContractCode: number;
  public JobOfferCode: number;
  public NurseActorCode: number;
  public HospitalActorCode: number;
  public ForwardedByRegistryActorCode: number;
  public JoinDate: Date;
  public Duration: number;
  public FromDate: Date;
  public ToDate: Date;
  public EmploymentType: string;
  public Remarks: string;
  public ContractStatus: string;
  public NurseDisplayName: string;
  public NurseImageFile: string;
  public NurseImageFileExtension: string;
  public NurseImageFileUrl: string;
  public NurseImageCode: number;
  public NurseAddressLine1: string;
  public NurseAddressLine2: string;
  public NurseCity: string;
  public NurseState: string;
  public NurseCountry: string;
  public NurseCountryLongValue: string;
  public NurseTelephone1: string;
  public NurseTelephone2: string;

  public RegistryAddressLine1: string;
  public RegistryAddressLine2: string;
  public RegistryCity: string;
  public RegistryState: string;
  public RegistryCountry: string;
  public RegistryCountryLongValue: string;
  public RegistryTelephone1: string;
  public RegistryTelephone2: string;
  public RegistryDisplayName: string;
  public HospitalAddressLine1: string;
  public HospitalAddressLine2: string;
  public HospitalCity: string;
  public HospitalState: string;
  public HospitalCountry: string;
  public HospitalCountryLongValue: string;
  public HospitalTelephone1: string;
  public HospitalTelephone2: string;
  public HospitalDisplayName: string;
}

export class RegistryJobContractsBetweenDateRequest extends BaseClass {
  public RegistryActorCode: number;
  public FromDate: Date;
  public ToDate: Date;
}
export class NurseJobContractsBetweenDateRequest extends BaseClass {
  public NurseActorCode: number;
  public FromDate: Date;
  public ToDate: Date;
}
export class NurseJobContractsBetweenDatesInfoController {
  public JobContractCode: number;
  public JobOfferCode: number;
  public NurseActorCode: number;
  public HospitalActorCode: number;
  public ForwardedByRegistryActorCode: number;
  public JoinDate: Date;
  public Duration: number;
  public FromDate: Date;
  public ToDate: Date;

  public EmploymentType: string;
  public Remarks: string;
  public ContractStatus: string;
  public NurseDisplayName: string;
  public NurseImageFile: string;
  public NurseImageFileExtension: string;
  public NurseImageFileUrl: string;
  public NurseImageCode: number;
  public NurseAddressLine1: string;
  public NurseAddressLine2: string;
  public NurseCity: string;
  public NurseState: string;
  public NurseCountry: string;
  public NurseCountryLongValue: string;
  public NurseTelephone1: string;
  public NurseTelephone2: string;
  public RegistryAddressLine1: string;
  public RegistryAddressLine2: string;
  public RegistryCity: string;
  public RegistryState: string;
  public RegistryCountry: string;
  public RegistryCountryLongValue: string;
  public RegistryTelephone1: string;
  public RegistryTelephone2: string;
  public RegistryDisplayName: string;
  public HospitalAddressLine1: string;
  public HospitalAddressLine2: string;
  public HospitalCity: string;
  public HospitalState: string;
  public HospitalCountry: string;
  public HospitalCountryLongValue: string;
  public HospitalTelephone1: string;
  public HospitalTelephone2: string;
  public HospitalDisplayName: string;
  public PayRate: number;

}

export class RegistryJobContractsBetweenDatesInfoController {
  public JobContractCode: number;
  public JobOfferCode: number;
  public NurseActorCode: number;
  public HospitalActorCode: number;
  public ForwardedByRegistryActorCode: number;
  public JoinDate: Date;
  public Duration: number;
  public FromDate: Date;
  public ToDate: Date;
  public EmploymentType: string;
  public Remarks: string;
  public ContractStatus: string;
  public NurseDisplayName: string;
  public NurseImageFile: string;
  public NurseImageFileExtension: string;
  public NurseImageFileUrl: string;
  public NurseImageCode: number;
  public NurseAddressLine1: string;
  public NurseAddressLine2: string;
  public NurseCity: string;
  public NurseState: string;
  public NurseCountry: string;
  public NurseCountryLongValue: string;
  public NurseTelephone1: string;
  public NurseTelephone2: string;
  public RegistryAddressLine1: string;
  public RegistryAddressLine2: string;
  public RegistryCity: string;
  public RegistryState: string;
  public RegistryCountry: string;
  public RegistryCountryLongValue: string;
  public RegistryTelephone1: string;
  public RegistryTelephone2: string;
  public RegistryDisplayName: string;
  public HospitalAddressLine1: string;
  public HospitalAddressLine2: string;
  public HospitalCity: string;
  public HospitalState: string;
  public HospitalCountry: string;
  public HospitalCountryLongValue: string;
  public HospitalTelephone1: string;
  public HospitalTelephone2: string;
  public HospitalDisplayName: string;
}

//
//export class ShiftAllocPatternsInfoController {
//  public HospitalActorCode: number;
//  public ParentCareUnitCode: number;
//  public CareUnitCode: number;
//  public ShiftTypeCode: number;
//  public StaffTypeCode: number;
//  public CareUnitType: string;
//  public ParentCareUnitName: string;
//  public CareUnitName: string;
//  public StaffType: string;
//  public ShiftType: string;
//  public Remarks: string;
//  public ShiftAllocPatternCode: number;
//}
//
export class ShiftAllocMasterByPatternCodeWithDateRequest extends BaseClass {
  public ShiftAllocPatternCode: number;
  public PatternDate: Date;
}

export class ShiftAllocMasterByPatternCodeWithDateInfoController {
  public ShiftAllocMasterCode: number;
  public ShiftAllocPatternCode: number;
  public HospitalActorCode: number;
  public Date: Date;
  public PlannedStaffCount: number;
  public ActualStaffCount: number;
  public Remarks: string;
  public NurseActorCode: number;
  public AllocationDate: Date;
  public ShiftStatus: string;
  public IsOvertime: boolean;
  public NurseDisplayName: string;
  public NurseImageFile: string;
  public NurseImageFileExtension: string;
  public NurseImageFileUrl: string;
  public NurseImageCode: number;
  public NurseAddressLine1: string;
  public NurseAddressLine2: string;
  public NurseCity: string;
  public NurseState: string;
  public NurseCountry: string;
  public NurseCountryLongValue: string;
  public NurseTelephone1: string;
  public NurseTelephone2: string;
  public CheckIn: string;
  public CheckOut: string;
  public LunchIn: string;
  public LunchOut: string;
  public StaffAttendanceCode: number;
}

export class StaffAllocInfoByShiftAllocMasterCodeRequest extends BaseClass {
  public ShiftAllocMasterCode: number;
}

export class StaffAllocInfoByShiftAllocMasterCodeController {
  public ShiftAllocMasterCode: number;
  public ShiftAllocPatternCode: number;
  public HospitalActorCode: number;
  public Date: Date;
  public PlannedStaffCount: number;
  public ActualStaffCount: number;
  public Remarks: string;
  public NurseActorCode: number;
  public AllocationDate: Date;
  public ShiftStatus: string;
  public IsOvertime: boolean;
}

export class HospitalActiveNursesInfoOnDateRequest extends BaseClass {
  public HospitalActorCode: number;
  public ShiftAllocMasterCode: number;
  public OnDate: Date;
}

export class HospitalActiveNursesInfoOnDateController {
  public NurseActorCode: number;
  public NurseDisplayName: string;
  public JoinDate: Date;
  public Duration: number;
  public FromDate: Date;
  public ToDate: Date;
  public RenewalType: string;
  public EmploymentType: string;
  public ContractStatus: string;
  public PreferedShiftType: string;
  public StaffType: string;
  public IsShiftAllocated: number;
}

export class ShiftAllocMasterByCareStaffShiftTypeWithDateInfoRequest extends BaseClass {
  public CareUnitCode: number;
  public ParentCareUnitCode: number;
  public StaffTypeCode: number;
  public ShiftTypeCode: number;
  public Date: Date;
}

export class ShiftAllocMasterByCareStaffShiftTypeWithDateInfoController {
  public ShiftAllocPatternCode: number;
  public ShiftAllocMasterCode: number;
  public HospitalActorCode: number;
  public ParentCareUnitCode: number;
  public CareUnitCode: number;
  public ShiftTypeCode: number;
  public StaffTypeCode: number;
  public CareUnitType: string;
  public ParentCareUnitName: string;
  public CareUnitName: string;
  public StaffType: string;
  public ShiftType: string;
  public Date: Date;
  public PlannedStaffCount: number;
  public ActualStaffCount: number;
  public Remarks: string;
  public CreatedUser: string;
  public CreatedTimeStamp: Date;
  public RecordStatus: string;
}


export class StaffAttendanceInfoByShiftTypeWithDateRequest extends BaseClass {
  public ShiftTypeCode: number;
  public Date: Date;
}


export class EmpNonAvailabilityCheckRequest extends BaseClass {

  public EmpNonAvailabilityCode: number;
  public NurseActorCode: number;
  public HospitalActorCode: number;
  public RequestedDate: Date;
  public RequestedToDate: Date;

}
export class EmpNonAvailabilityRequest extends BaseClass {
  public EmpNonAvailabilityCode: number;
  public HospitalActorCode: number;
  public NurseActorCode: number;
  public RequestedDate: Date;
  public Reason: string;
  public Remarks: string;
  public IsAvailable: boolean;

}

export class EmpNonAvailabilityController 
{
  public EmpNonAvailabilityCode: number;
  public Availability: string ;
  public Reason: string ;
  public Remarks: string;
  public RequestedDate: Date;


}

export class MasterH2RContractGetRequest extends BaseClass  {
  public HospitalActorCode: number;
  public RegistryActorCode: number;
  public RequestedDate: Date;
   

}

export class MasterH2RContractRequest extends BaseClass {


  public MasterH2RContractCode: number;
  public RegistryActorCode: number;
  public FromDate: Date;
  public ToDate: Date;
  public PayRate: number;
  public R2NPayRate: number;
  public RenewalType: string;
  public HospitalActorCode: number;
  public EmploymentType: string;
  public PreferedShiftTypeCode: number;
  public PreferedShiftType: string;
  public Remarks: string;
}

export class MasterH2RContractController {
  public MasterH2RContractCode: number;
  public RegistryActorCode: number;
  public FromDate: Date;
  public ToDate: Date;
  public PayRate: number;
  public R2NPayRate: number;
  public RenewalType: string;
  public HospitalActorCode: number;
  public EmploymentType: string;
  public StaffType: string;
  public StaffTypeCode: number;
  public PreferedShiftTypeCode: number;
  public PreferedShiftType: string;
  public Remarks: string;
  public CreatedUser: string;
  public CreatedTimeStamp: Date;
  public RecordStatus: string;  
  public Specialty: string;
}
export class MasterH2RContractAddRequest extends BaseClass {
  public RegistryActorCode: number;
  public FromDate: Date;
  public ToDate: Date;
  public PayRate: number;
  public R2NPayRate: number;
  public RenewalType: string;
  public HospitalActorCode: number;
  public EmploymentType: string;
  public StaffType: string;
  public StaffTypeCode: number;
  public PreferedShiftTypeCode: number;
  public PreferedShiftType: string;
  public Remarks: string;
  public CreatedUser: string;
  public CreatedTimeStamp: Date;
  public RecordStatus: string;
}


export class StaffAttendanceInfoByShiftTypeWithDateController {
  public HospitalActorCode: number;
  public NurseActorCode: number;
  public ShiftAllocationCode: number;
  public Date: Date;
  public CheckIn: string;
  public CheckOut: string;
  public LunchIn: string;
  public LunchOut: string;
  public NurseDisplayName: string;
  public NurseImageFile: string;
  public NurseImageFileExtension: string;
  public NurseImageFileUrl: string;
  public NurseImageCode: number;
  public NurseAddressLine1: string;
  public NurseAddressLine2: string;
  public NurseCity: string;
  public NurseState: string;
  public NurseCountry: string;
  public NurseCountryLongValue: string;
  public NurseTelephone1: string;
  public NurseTelephone2: string;
  public StaffAttendanceCode: number;
  public StaffAttendanceRemarks: string;
}


export class StaffAttendanceInfoRequest extends BaseClass {
  public StaffAttendanceCode: number;
  public CheckIn: string;
  public CheckOut: string;
  public LunchIn: string;
  public LunchOut: string;
}

export class AddEmployeeToResourcePoolRequest extends BaseClass {
  public HospitalActorCode: number;
  
  public Name :string  ;
  public ShiftDeail: string;
  public ShiftCode: number;
  public AvailableSince: Date; 
  public StaffType: string ;
  public StaffTypeCode : number;
  public Specialty:string  ;
  public IsFirm: number;
  public RecordStatus : string ;
  public Phone :string ;
  public Email: string ;
  public Remarks :string ;
  public Photo: number;
  public Department: string;
  public DepartmentCode: number;





}
export class ShiftAllocationsByJobIDRequest extends BaseClass {
  public JobID: number;
  //  public long NurseActorCode { get; set; }
}


export class JobApplicantsByJobIDRequest extends BaseClass
{
  public JobID: number;
  //  public long NurseActorCode { get; set; }
}


export class JobApplicantsByJobIDController {
  public JobOrderCode: number;
  public JobCode: number;
  public OrderDate: Date;
  public HospitalActorCode: number;
  public RegistryActorCode: number;
  public OrderCount: number;
  public OrderStatus: string;
  public ProposedCopmpensation: string;
  public Remarks: string;
  public JoinByDate: Date;
  public JobType: string;
  public JobDescription: string;
  public ContractPeriodInDays: number;
  public CareUnitName: string;
  public StaffType: string;
  public StaffTypeCode: number;
  public ShiftType: string;
  public ShiftTypeCode: number;
  public ShiftFromTime: string;
  public ShiftToTime: string;
  public StaffDesc: string;
  public HospitalDisplayName: string;
  public HospitalFacilityCode: number;
  public RegistryDisplayName: string;
  public RegistryFacilityCode: number;
  public JobPostCount: number;
  public JobPostBenefits: string;
  public JobPostDescription: string;
  public JobPostCode: number;
  public PostedDate: Date;
  public ApplicationDate: Date;
  public ApplicationStatus: string;
  public ApplicationRemarks: string;
  public JobApplicationCode: number;
  public HospitalAddressLine1: string;
  public HospitalAddressLine2: string;
  public HospitalCity: string;
  public HospitalState: string;
  public HospitalCountry: string;
  public HospitalCountryLongValue: string;
  public HospitalTelephone1: string;
  public HospitalTelephone2: string;
  public RegistryAddressLine1: string;
  public RegistryAddressLine2: string;
  public RegistryCity: string;
  public RegistryState: string;
  public RegistryCountry: string;
  public RegistryCountryLongValue: string;
  public RegistryTelephone1: string;
  public RegistryTelephone2: string;
  public NurseDisplayName: string;
  public NurseImageFile: string;
  public NurseImageFileExtension: string;
  public NurseImageFileUrl: string;
  public NurseImageCode: number;
  public NurseActorCode: number;

  public JobApplicationForwardCode: number;
  public ApplicationForwardStatus: string;
  public ApplicationForwardDate: Date;
  public ForwardRemarks: string;


  public JobOfferCode: number;
  public JoinDateProposed: Date;
  public OfferDate: Date;
  public OfferStatus: string;
  public OfferRemarks: string;

  public IsSelected: boolean;
}

export class GetmpEmployeeResourcePoolRequest extends BaseClass {
  public HospitalActorCode: number;
  public StaffType: string;
  public Specialty: string;
  public FromDate: Date;
  public ToDate: Date;
  public IsFirm: boolean;

  public Department: string ;
  public DepartmentCode: number;
  public PreferredShift: string ;
  public PreferredShiftCode: number;


}

export class EmployeeResourcePoolController {

  public EmployeeResourcePoolCode: number;
  public ResourceCode: number;
  public HospitalActorCode: number;
  public FromDate: Date;
  public ToDate: Date;
  public StaffType: string;
  public StaffTypeCode: number;
  public Specialty: string;
  public IsFirm: boolean;
  public RecordStatus: string;
  public State: string
  public CountryLongValue: string
  public Telephone1: string
  public Telephone2: string
  public Email: string
  public LastName: string
  public DisplayName: string
  public ActorImageFile: string
  public ActorImageFileExtension: string
  public ActorImageFileUrl: string
  public ActorImageCode: number;
  public Department: string;
  public DepartmentCode: number;
  public PreferredShift: string;
  public PreferredShiftCode: number;
}
